import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Seo from "../components/Seo";

const LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Les cotes", to: "/comprendre/les-cotes" },
  { label: "Cadre légal", to: "/cadre-legal/anj" },
  { label: "Glossaire", to: "/comprendre/glossaire" },
  { label: "Jeu responsable", to: "/jeu-responsable" },
];

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page introuvable"
        description="Cette page n'existe pas ou a été déplacée. Retrouvez les guides essentiels."
        path="/404"
      />
      <div className="mx-auto flex max-w-[760px] flex-col items-start px-4 py-20 sm:px-6 sm:py-28">
        <Compass className="mb-6 h-12 w-12 text-[#2BB08A]" aria-hidden="true" />
        <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-slate-400">
          Erreur 404
        </p>
        <h1
          data-testid="notfound-title"
          className="mt-2 font-display text-4xl font-bold tracking-tight text-[#0B1F3A] sm:text-5xl"
        >
          Page introuvable
        </h1>
        <p className="mt-4 text-lg leading-relaxed text-slate-600">
          Cette page n'existe pas ou a été déplacée. Retrouvez les guides essentiels ci-dessous.
        </p>
        <div className="mt-8 flex flex-wrap gap-3" data-testid="notfound-links">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="rounded-full border border-slate-300 px-5 py-2.5 font-display text-sm font-semibold text-[#0B1F3A] transition-colors hover:border-[#2BB08A] hover:bg-[#E8F8F3]"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
